import "./index.css";
import InfoBox from "./InfoBox";
import ic_phone from "./ic_phone.svg";
import ic_address from "./ic_address.svg";
import ic_email from "./ic_email.svg";

function ContactUs() {
    const mailTo = () => {
        window.location.href = "mailto:business@bizcon.info";
    };

    return (
        <div id="contact" className="contact_block">
            <div className="contact_left">
                <div className="contact_title">Contact Us</div>
                <div className="contact_desc">
                    Find the contact details you like to contact us.
                </div>
            </div>
            <div className="contact_right">
                <InfoBox title="Tel" icon={ic_phone} text="+63 9690596886" />
                <InfoBox
                    title="Email"
                    icon={ic_email}
                    text="business@bizcon.info"
                />
                <InfoBox
                    title="Address"
                    icon={ic_address}
                    text="Unit 226 Makati Executive Tower 3, Gil Puyat, Makati City"
                />
                <div className="buttonLayout">
                    <div className="emailBtn" onClick={mailTo}>
                        Contact Us
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactUs;
